export enum TariffType {
  Basic = 1, // Базовый
  Full = 2, // Полный
  FullPlus = 3, // Полный Плюс
  Archive = 666, // Архив
}
